if (!customElements.get('td-faq-accordion')) {
  const SELECTORS = {
    item: '[data-td-faq-item]',
    button: '[data-td-faq-button]',
    panel: '[data-td-faq-panel]'
  };

  class TdFaqAccordion extends HTMLElement {
    constructor() {
      super();
      this.buttons = [];
      this.sectionId = '';
      this.boundHandleToggle = this.handleToggle.bind(this);
      this.boundHandleKeydown = this.handleKeydown.bind(this);
      this.boundHandleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId || '';
      this.buttons = [...this.querySelectorAll(SELECTORS.button)];
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.boundHandleToggle);
        button.addEventListener('keydown', this.boundHandleKeydown);
      });

      document.addEventListener('shopify:block:select', this.boundHandleBlockSelect);
    }

    disconnectedCallback() {
      this.buttons.forEach((button) => {
        button.removeEventListener('click', this.boundHandleToggle);
        button.removeEventListener('keydown', this.boundHandleKeydown);
      });

      document.removeEventListener('shopify:block:select', this.boundHandleBlockSelect);
    }

    handleToggle(event) {
      const button = event.currentTarget;
      const item = button.closest(SELECTORS.item);

      if (!item) return;

      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        this.setItemState(item, false);
        return;
      }

      this.setItemState(item, true);
    }

    handleKeydown(event) {
      const currentIndex = this.buttons.indexOf(event.currentTarget);
      let targetIndex = -1;

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          targetIndex = (currentIndex + 1) % this.buttons.length;
          break;
        case 'ArrowUp':
          event.preventDefault();
          targetIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
          break;
        case 'Home':
          event.preventDefault();
          targetIndex = 0;
          break;
        case 'End':
          event.preventDefault();
          targetIndex = this.buttons.length - 1;
          break;
        case 'Escape':
          this.setItemState(event.currentTarget.closest(SELECTORS.item), false);
          event.currentTarget.focus();
          break;
      }

      if (targetIndex >= 0) {
        this.buttons[targetIndex].focus();
      }
    }

    handleBlockSelect(event) {
      if (this.sectionId && event.detail?.sectionId && event.detail.sectionId !== this.sectionId) return;

      const item = event.target.closest(SELECTORS.item);

      if (!item || !this.contains(item)) return;

      this.setItemState(item, true);

      const button = item.querySelector(SELECTORS.button);
      button?.focus();
    }

    setItemState(item, expanded) {
      if (!item) return;

      const button = item.querySelector(SELECTORS.button);
      const panel = item.querySelector(SELECTORS.panel);

      if (!button || !panel) return;

      item.dataset.open = expanded ? 'true' : 'false';
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    }
  }

  customElements.define('td-faq-accordion', TdFaqAccordion);
}